import React from 'react'
import {Box, Flex, Grid} from '@chakra-ui/react'
import MenuGroupedCategories from '../../list-menu/partials/MenuGroupedCategories'
import MenuVerticalCard from '../../list-menu/partials/MenuVerticalCard'
import {getTemplateLinks} from '../../list-menu/partials/templates/shared'
import {
    DrawerLinkButtons,
    compactGap,
    drawerTemplatePropTypes,
    fullHeightChildSx,
    groupedCategoriesProps,
    templateGridGap,
    templateGridGapSx,
} from './shared'
import {remCalc} from '../../../theme/_utils'

export const getDrawerTemplateThreeData = (primarycategory) => ({
    categoryGroup: primarycategory?.category_group ?? [],
    links: getTemplateLinks(primarycategory),
    verticalCards: [primarycategory?.image_1, primarycategory?.image_2].filter(Boolean),
})

const DrawerTemplateThree = ({primarycategory, categoryData, locale, styles}) => {
    const {categoryGroup, links, verticalCards} = getDrawerTemplateThreeData(primarycategory)

    return (
        <Box
            w="100%"
            pb={remCalc(64)}
            sx={{'@media screen and (min-width: 2000px)': {paddingBottom: 'unset'}}}
            data-primarycategory-id={primarycategory?.uid}
        >
            <Grid
                templateColumns={{base: '1fr', sm: '1fr', md: '1fr 2fr'}}
                gap={templateGridGap}
                sx={templateGridGapSx}
                alignItems="start"
            >
                <Flex
                    flexDir="column"
                    gap={templateGridGap}
                    sx={templateGridGapSx}
                    gridColumn={{base: '1 / -1', sm: '1 / -1', md: '1 / 2'}}
                >
                    {categoryData && categoryGroup.length > 0 && (
                        <Box {...groupedCategoriesProps}>
                            <MenuGroupedCategories
                                groupedCategories={categoryGroup}
                                locale={locale}
                                categoryData={categoryData}
                                styles={styles}
                                groupLinkGap={remCalc(8)}
                            />
                        </Box>
                    )}

                    {links.length > 0 && (
                        <Flex flexDir="column" gap={2}>
                            <DrawerLinkButtons
                                links={links}
                                categoryData={categoryData}
                                locale={locale}
                                styles={styles}
                            />
                        </Flex>
                    )}
                </Flex>

                {verticalCards.length > 0 && (
                    <Flex
                        gridColumn={{base: '1 / -1', sm: '1 / -1', md: '2 / 3'}}
                        flexDir="column"
                        gap={compactGap}
                        alignItems="flex-start"
                        maxHeight="100%"
                    >
                        {verticalCards.map((card, idx) => (
                            <Box
                                key={
                                    card?._metadata?.uid ??
                                    `drawer-menu-template-three-vertical-card-${idx}`
                                }
                                w="100%"
                                aspectRatio={idx === 0 ? 1.33 : 0.74}
                                sx={fullHeightChildSx}
                                maxHeight="100%"
                                overflowY="auto"
                            >
                                <MenuVerticalCard
                                    card={card}
                                    categoriesData={categoryData}
                                    locale={locale}
                                />
                            </Box>
                        ))}
                    </Flex>
                )}
            </Grid>
        </Box>
    )
}

DrawerTemplateThree.propTypes = drawerTemplatePropTypes

export default DrawerTemplateThree
